'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = withFilter;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactRouterDom = require('react-router-dom');

var _reactRouterRedux = require('react-router-redux');

var _fp = require('lodash/fp');

var _fp2 = _interopRequireDefault(_fp);

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreNamedRoutes2 = _interopRequireDefault(_bdcoreNamedRoutes);

var _bdcoreUtilities = require('@bd/bdcore-utilities');

var _actions = require('./actions');

var _FilterCollection = require('./FilterCollection');

var _selectors = require('../Homes/selectors');

var _selectors2 = require('../Lots/selectors');

var _selectors3 = require('../Plans/selectors');

var _selectors4 = require('../Blogposts/selectors');

var _selectors5 = require('../Communities/selectors');

var _selectors6 = require('../Builder/selectors');

var _filters = require('../Homes/filters');

var _filters2 = require('../Lots/filters');

var _filters3 = require('../Communities/filters');

var _filters4 = require('../Plans/filters');

var _filters5 = require('../Blogposts/filters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var types = {
  homes: {
    selector: _selectors.getHomes,
    collectDependencies: _filters.getHomeCollectDependencies
  },
  lots: {
    selector: _selectors2.getLots,
    collectDependencies: _filters2.getLotCollectDependencies
  },
  plans: {
    selector: _selectors3.getPlans,
    collectDependencies: _filters4.getPlanCollectDependencies
  },
  communities: {
    selector: _selectors5.getCommunities,
    collectDependencies: _filters3.getCommunityCollectDependencies
  },
  blogposts: {
    selector: _selectors4.getBlogposts,
    collectDependencies: _filters5.getBlogpostCollectDependencies
  }
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function collectFilterValues(state, ownProps, filter) {
  var filterObj = void 0;
  var collectValues = void 0;
  var collectDependencies = void 0;
  var dependencies = {};
  var data = [];
  var type = ownProps.type,
      _ownProps$builderId = ownProps.builderId,
      builderId = _ownProps$builderId === undefined ? _bdcoreUtilities.ConfigStore.getConfig('builder_id') : _ownProps$builderId;

  var selectorOptions = (0, _extends4.default)({ onlyFilters: _fp2.default.getOr(['Area', 'AreaMetro'], 'onlyFilters', ownProps) }, ownProps, { builderId: builderId });

  if (_fp2.default.has((type || '').toLowerCase(), types)) {
    var typeConfig = _fp2.default.get((type || '').toLowerCase(), types);
    data = _fp2.default.get('selector', typeConfig, function () {})(state, selectorOptions);
    filterObj = _fp2.default.get(filter, (0, _FilterCollection.getFilters)(type));
    collectValues = _fp2.default.get('collectValues', filterObj);
    collectDependencies = _fp2.default.get('collectDependencies', typeConfig, function () {});

    if (!collectValues) {
      throw Error('ERROR:: FILTER:: CollectValues for filter ' + filter + ' does not exist for type ' + type);
    }
  } else {
    throw Error('ERROR:: FILTER:: No filters exist for type ' + type);
  }

  var builderData = {
    communities: _fp2.default.get('cloudData.communities.' + builderId + '.data', state),
    homes: _fp2.default.get('cloudData.homes.' + builderId + '.data', state),
    lots: _fp2.default.get('cloudData.lots.' + builderId + '.data', state),
    plans: _fp2.default.get('cloudData.plans.' + builderId + '.data', state),
    widgets: _fp2.default.get('cloudData.settings.' + builderId + '.data.widgets', state),
    areas: (0, _selectors6.getAreas)(state, { builderId: builderId, all: true })
  };

  if (Array.isArray(filterObj.dependencies)) {
    dependencies = collectDependencies({
      state: state,
      type: type,
      data: data,
      dependencies: filterObj.dependencies,
      builderData: builderData
    });

    if (filterObj.dependencies.find(function (dep) {
      return dep.includes('widget:');
    })) {
      filterObj.dependencies.filter(function (dep) {
        return dep.includes('widget:');
      }).forEach(function (dep) {
        var _dep$split = dep.split(':'),
            _dep$split2 = (0, _slicedToArray3.default)(_dep$split, 2),
            widgetKey = _dep$split2[1];

        var widget = (builderData.widgets || []).find(function (w) {
          return _fp2.default.get('meta.key', w) === widgetKey;
        });

        if (widget) {
          dependencies[widgetKey] = widget;
        }
      });
    }
  }

  var values = collectValues(data, (0, _extends4.default)({}, dependencies, state.filters, { config: filterObj })).map(function (value) {
    var labelRender = _fp2.default.getOr(function (val) {
      return val;
    }, 'labelRender', filterObj);
    var activeLabelRender = _fp2.default.getOr(function () {
      return undefined;
    }, 'activeLabelRender', filterObj);
    value.label = labelRender(value); // eslint-disable-line
    value.activeLabel = activeLabelRender(value); // eslint-disable-line
    return value;
  });

  return values;
}

function withFilter(filter) {
  return function (WrappedComponent) {
    var WithFilter = function (_React$Component) {
      (0, _inherits3.default)(WithFilter, _React$Component);

      function WithFilter() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, WithFilter);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithFilter.__proto__ || (0, _getPrototypeOf2.default)(WithFilter)).call.apply(_ref, [this].concat(args))), _this), _this.setFilter = function (value) {
          var keepParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
          var _this$props = _this.props,
              dispatch = _this$props.dispatch,
              saveInQueryString = _this$props.saveInQueryString,
              routeParam = _this$props.routeParam,
              noRedirect = _this$props.noRedirect,
              filterType = _this$props.filterType;


          dispatch((0, _actions.setFilter)(filter, value));
          _bdcoreUtilities.GlobalEvents.emit('withFilter::setFilter', { filter: filter, values: value });

          if (!noRedirect && !keepParams && routeParam && (filterType !== 'MultiSelect' || (value || []).length === 1)) {
            _this.handleUrlUpdate((value || []).length ? value[0] : value);
          } else if (saveInQueryString || saveInQueryString && filterType === 'MultiSelect' && (value || []).length > 1) {
            _this.handleQueryString(Array.isArray(value) ? value : [value]);
          }
        }, _this.unsetFilter = function () {
          var dispatch = _this.props.dispatch;

          dispatch((0, _actions.setFilter)(filter, null));
          _this.handleQueryString([]);
        }, _this.removeValue = function (valueToRemove, keepParams) {
          var value = _this.props.value;

          var newValue = value.filter(function (filterVal) {
            return filterVal !== valueToRemove;
          });

          _this.setFilter(newValue, keepParams);
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
      }

      (0, _createClass3.default)(WithFilter, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          this.unsetMissingOptions();
        }
      }, {
        key: 'componentWillUpdate',
        value: function componentWillUpdate() {
          this.unsetMissingOptions();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.unsetMissingOptions();
        }
      }, {
        key: 'unsetMissingOptions',
        value: function unsetMissingOptions() {
          var _props = this.props,
              value = _props.value,
              values = _props.values,
              unsetMissingOptions = _props.unsetMissingOptions;

          if (values.length && value.length && unsetMissingOptions) {
            var retainedValues = value.filter(function (val) {
              return values.find(function (option) {
                return option.label === val.label;
              });
            });

            if (_fp2.default.xorBy('label', retainedValues, value).length > 0) {
              this.setFilter(retainedValues);
            }
          }
        }
      }, {
        key: 'handleQueryString',
        value: function handleQueryString(value) {
          var _props2 = this.props,
              dispatch = _props2.dispatch,
              type = _props2.type,
              routeName = _props2.routeName,
              match = _props2.match,
              routeParam = _props2.routeParam;


          var urlParams = new URLSearchParams(window.location.search);
          var filters = JSON.parse(urlParams.get('filters') || '{}');

          var urlFilterValues = (value || []).filter(function (v) {
            return v;
          }).map(function (v) {
            return v.label;
          });

          if (!urlFilterValues.length && filters[this.props.filter]) {
            delete filters[this.props.filter];
          } else if (urlFilterValues.length) {
            filters[this.props.filter] = urlFilterValues;
          }

          if (!(0, _keys2.default)(filters).length) {
            urlParams.delete('filters');
          } else {
            urlParams.set('filters', (0, _stringify2.default)(filters));
          }

          var matchParams = _fp2.default.getOr({}, 'params', match);
          delete matchParams[routeParam];

          var url = _bdcoreNamedRoutes2.default.getPath(routeName || type, matchParams);

          dispatch((0, _reactRouterRedux.push)(url + '?' + urlParams.toString()));
        }
      }, {
        key: 'handleUrlUpdate',
        value: function handleUrlUpdate(value) {
          var _props3 = this.props,
              dispatch = _props3.dispatch,
              filterOptions = _props3.filterOptions,
              type = _props3.type,
              routeParam = _props3.routeParam,
              routeName = _props3.routeName,
              match = _props3.match,
              parent = _props3.parent;


          var url = void 0;
          if (value) {
            var matchParams = _fp2.default.getOr({}, 'params', match);
            var paramValue = value.label;
            var pathParams = (0, _extends4.default)({}, matchParams, (0, _defineProperty3.default)({}, routeParam, paramValue));

            if (parent && parent.options.routeParam) {
              // Find parent and add routeParam if configured
              var parentValue = parent.values.find(function (pv) {
                return filterOptions.parent.match({ self: value, parent: pv });
              });

              if (parentValue && parent.options.routeParam) {
                pathParams[parent.options.routeParam] = parentValue.label;
              }
            }

            if (filterOptions.child) {
              // Clear child filter routeParam if configured
              var _$getOr = _fp2.default.getOr({}, filterOptions.child, (0, _FilterCollection.getFilters)(type)),
                  childRouteParam = _$getOr.routeParam;

              if (childRouteParam && _fp2.default.has(childRouteParam, pathParams)) {
                delete pathParams[childRouteParam];
              }
            }

            url = _bdcoreNamedRoutes2.default.getPath(routeName || type, pathParams);
          } else if (!value) {
            var _$getOr2 = _fp2.default.getOr({}, 'params', match),
                param = _$getOr2[routeParam],
                _matchParams = (0, _objectWithoutProperties3.default)(_$getOr2, [routeParam]);

            if (filterOptions.child) {
              // Clear child filter routeParam if configured
              var _$getOr3 = _fp2.default.getOr({}, filterOptions.child, (0, _FilterCollection.getFilters)(type)),
                  _childRouteParam = _$getOr3.routeParam;

              if (_childRouteParam && _fp2.default.has(_childRouteParam, _matchParams)) {
                delete _matchParams[_childRouteParam];
              }
            }
            url = _bdcoreNamedRoutes2.default.getPath(routeName || type, _matchParams);
          }

          dispatch((0, _reactRouterRedux.push)(url));
        }
      }, {
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, (0, _assign2.default)({}, this.props, {
            setFilter: this.setFilter,
            unsetFilter: this.unsetFilter,
            removeValue: this.removeValue
          }));
        }
      }]);
      return WithFilter;
    }(_react2.default.Component);

    WithFilter.propTypes = {
      dispatch: _propTypes2.default.func.isRequired,
      filterOptions: _propTypes2.default.object.isRequired,
      match: _propTypes2.default.object.isRequired,
      routeParam: _propTypes2.default.string,
      filter: _propTypes2.default.string.isRequired,
      type: _propTypes2.default.string.isRequired,
      filterType: _propTypes2.default.string.isRequired,
      routeName: _propTypes2.default.string,
      noRedirect: _propTypes2.default.bool,
      parent: _propTypes2.default.object,
      saveInQueryString: _propTypes2.default.bool,
      unsetMissingOptions: _propTypes2.default.bool,
      value: _propTypes2.default.arrayOf(_propTypes2.default.object),
      values: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
    };

    WithFilter.defaultProps = {
      routeParam: undefined,
      routeName: undefined,
      noRedirect: false,
      parent: undefined,
      saveInQueryString: false,
      unsetMissingOptions: false,
      value: []
    };

    WithFilter.displayName = 'WithFilter(' + getDisplayName(WrappedComponent) + ')';

    function makeMapStateToProps(state, ownProps) {
      var filters = state.filters;

      var filterOptions = _fp2.default.getOr({}, filter, (0, _FilterCollection.getFilters)(ownProps.type));
      var parent = void 0;
      if (filterOptions.parent) {
        parent = {
          options: _fp2.default.getOr({}, filterOptions.parent.filter, (0, _FilterCollection.getFilters)(ownProps.type)),
          values: collectFilterValues(state, ownProps, filterOptions.parent.filter)
        };
      }
      return {
        values: collectFilterValues(state, ownProps, filter),
        value: _fp2.default.get(filter, filters),
        filterOptions: filterOptions,
        parent: parent
      };
    }

    return (0, _reactRedux.connect)(makeMapStateToProps)((0, _reactRouterDom.withRouter)(WithFilter));
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-data/build/Filters/withFilter.js
// module id = 528
// module chunks = 0